import { Link } from '@mui/material'
import CompliancePlip from '../../../../components/CompliancePlip'
import { ComplianceStatus } from '../../../../types'
import useCustomer from '../../../../hooks/useCustomer'

interface WaterlineProps {
  link: string
}

const Waterline = ({ link }: WaterlineProps) => {
  const customer = useCustomer()
  const metadata = customer.customerMetadata

  return metadata && (
    <div className='border-box'>
      <div>
        <CompliancePlip message='' className='dashboard-compliance' status={metadata.waterline_compliance_status} />
      </div>
      <div className='compliance-message'>
        <p className='card-info'>{metadata.waterline_message_long}</p>
        <Link className='small-text' href={link}>{metadata.waterline_compliance_status === ComplianceStatus.Inactive ? 'Learn More' : 'View Details'}</Link>
      </div>
    </div>
  )
}

export default Waterline